module.exports = __webpack_public_path__ + "img/person.81ed48a3.png";